export interface IMediaPlaybackStateInfo {
  appKey?: string;
  customid?: string;
  durationMsec?: number;
  isAudioVideoSwitchEnabled?: boolean;
  isBuffering?: boolean;
  isComplete?: boolean;
  isLiveStream?: boolean;
  isLoading?: boolean;
  isPlaying?: boolean;
  isSeekable?: boolean;
  isSeeking?: boolean;
  isVideo?: boolean;
  isInterrupted?: boolean;
  mediaItemShortCode?: string;
  playId?: string;
  playlistIndex?: number;
  positionMsec?: number;
  savedStateKey?: string;
}

export interface IPlaylistItemData {
  customid?: string;
  mediaItemShortCode?: string;
  playId?: string;
  savedStateKey?: string;
}

/** https://subsplash.atlassian.net/wiki/spaces/PLAT/pages/505446585/Media+Analytics+Play+Tracking#Play-Positions */
export enum PlayerEvents {
  downloadAudio = 'download-audio',
  downloadVideo = 'download-video',
  ended = 'ended',
  fullscreenEnter = 'fullscreen-enter',
  fullscreenExit = 'fullscreen-exit',
  pause = 'pause',
  play = 'play',
  promptClick = 'prompt-click',
  promptShow = 'prompt-show',
  replay = 'replay',
  resumePlay = 'resume-play',
  seeked = 'seeked',
  skipBackward = 'skip-backward',
  skipForward = 'skip-forward',
  startMedia = 'start-media',
  startOver = 'start-over',
  switchToAudio = 'switch-to-audio',
  switchToVideo = 'switch-to-video',
  mute = 'mute',
  unmute = 'unmute',
  subtitlesDisabled = 'subtitles-disabled',
  subtitlesEnabled = 'subtitles-enabled',
  playbackSpeedUpdate = 'playback-speed-update',
  adaptiveBitrateChange = 'adaptive-bitrate-change',
  give = 'give',
  share = 'share',
}
